import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'

import { accountsService } from 'src/services/accounts.service'
import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'
import { ICustomIconFile } from 'src/types'

interface IUpdateAccountIcon {
  image: ICustomIconFile
  oldImage: string
  image_small?: string
  image_medium?: string
}

const useUpdateAccountIcon = () => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(
    async ({ image, oldImage, image_medium, image_small }: IUpdateAccountIcon) => {
      let updatedIcons = await mediaEntityUploadService.updateIcon(oldImage, image)

      if (!updatedIcons) {
        updatedIcons = []
        image.icon && updatedIcons.push(image.icon)
        image_small && updatedIcons.push(image_small)
        image_medium && updatedIcons.push(image_medium)
      }

      if (updatedIcons.length <= 2) {
        for (let i = 0; i <= 3 - updatedIcons.length; i++) {
          updatedIcons.push(null)
        }
      }

      return accountsService.updateIcon(accountId!, updatedIcons)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT, accountId])
      },
    },
  )
}

export { useUpdateAccountIcon }
